<template>
  <div>
    <h1>Muchomorkowe losowanie</h1>
    <br>
    <br>
    <br>
    <b-button variant="danger" @click="chooseOne">Losuj!</b-button>
    <br>
    <br>
    <br>
    <div>
      <h1 class="animated zoomIn delay-2s">{{ winner }}</h1>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'Chooser',
  props: {
    msg: String,
  },
  data() {
    return {
      winner: null,
      showSpinner: false,
    };
  },
  methods: {
    chooseOne() {
      this.showSpinner = true;
      this.winner = null;
      axios({
        method: 'get',
        url: 'https://k9dzjjtfvi.execute-api.eu-central-1.amazonaws.com/dev',
      }).then((response) => {
        this.winner = response.data.winner;
        this.showSpinner = false;
      });
    },
  },
};
</script>

<style>
</style>
